module.exports = __webpack_public_path__ + "img/envelope.02c9e7de.png";